import React, { useMemo } from 'react';
import MasterScopeScreen from './MasterScopeScreen';

const MasterScopeScreenForm = ({ models, documentGroupId }) => {
    const memoizedModels = useMemo(() => models, [models]);

    const memoizedRelationFilters = useMemo(() => ({
        "Document": [{
            field: "DocumentGroupId",
            operator: "is",
            type: "Number",
            value: documentGroupId
        }]
    }), [documentGroupId]);

    return (
        <MasterScopeScreen.Form
            models={memoizedModels}
            relationFilters={memoizedRelationFilters}
        />
    );
};

export default React.memo(MasterScopeScreenForm);
